export default __webpack_public_path__ + "static/media/info.8b4e18dd.svg";